var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapeVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C20.8495 32.0127 25.1947 29.8549 28.1288 26.4475H3.87122C6.8054 29.8549 11.1506 32.0127 16 32.0127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0127C32 7.1762 24.8365 0.0126953 16 0.0126953C7.1635 0.0126953 0 7.1762 0 16.0127C0 17.4569 0.1925 18.8558 0.551188 20.1866H31.4489C31.8075 18.8558 32 17.4569 32 16.0127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27161 22.2737C1.58004 22.9985 1.94061 23.6955 2.34829 24.3607H29.6515C30.0591 23.6954 30.4197 22.9984 30.7282 22.2737H1.27161Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4368 17.0562L11.6958 17.8533H12.534L11.856 18.346L12.115 19.1431L11.4368 18.6504L10.7587 19.1431L11.0178 18.346L10.3397 17.8533H11.1779L11.4368 17.0562Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4368 27.4911L11.6958 28.2883H12.534L11.856 28.7809L12.115 29.578L11.4368 29.0854L10.7587 29.578L11.0178 28.7809L10.3397 28.2883H11.1779L11.4368 27.4911Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57942 23.962L6.83842 24.7591H7.67661L6.99855 25.2517L7.25755 26.049L6.57942 25.5563L5.9013 26.049L6.16042 25.2517L5.4823 24.7591H6.32042L6.57942 23.962Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43471 18.0995L8.69371 18.8967H9.53183L8.85383 19.3893L9.11283 20.1865L8.43471 19.6938L7.75659 20.1865L8.01571 19.3893L7.33752 18.8967H8.17571L8.43471 18.0995Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4823 21.3822L6.3203 21.3823L6.57936 20.585L6.83842 21.3822L7.67661 21.3821L6.99849 21.8748L7.25755 22.672L6.57936 22.1793L5.9013 22.6718L6.1603 21.8748L5.4823 21.3822Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75659 28.3822L8.01559 27.5852L7.3374 27.0925H8.17559L8.43465 26.2953L8.69372 27.0925H9.53184L8.85371 27.5851L9.11271 28.3823L8.43459 27.8896L7.75659 28.3822Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2923 23.962L16.0334 24.7591H15.1952L15.8732 25.2517L15.6142 26.049L16.2923 25.5563L16.9704 26.049L16.7114 25.2517L17.3895 24.7591H16.5513L16.2923 23.962Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.437 18.0995L14.178 18.8967H13.3398L14.0178 19.3893L13.7588 20.1865L14.437 19.6938L15.1151 20.1865L14.856 19.3893L15.5342 18.8967H14.696L14.437 18.0995Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3895 21.3822L16.5514 21.3823L16.2924 20.585L16.0334 21.3822L15.1952 21.3821L15.8732 21.8748L15.6142 22.672L16.2924 22.1793L16.9704 22.6718L16.7114 21.8748L17.3895 21.3822Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1151 28.3822L14.8562 27.5852L15.5343 27.0925H14.6961L14.437 26.2953L14.178 27.0925H13.3398L14.018 27.5851L13.759 28.3823L14.4371 27.8896L15.1151 28.3822Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapeVerde);
export default __webpack_public_path__ + "static/media/cape-verde.eb142a34.svg";
export { ForwardRef as ReactComponent };